(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .service('ControllerCustomService', ControllerCustomService);

    ControllerCustomService.$inject = ['$http'];

    function ControllerCustomService($http) {
        var service = {
            getControllersByShipment: getControllersByShipment,
            getControllersByInvoice: getControllersByInvoice,
            getControllersByShipmentAndInvoice: getControllersByShipmentAndInvoice,
            returnUsedShipments: returnUsedShipments,
            returnUsedInvoices: returnUsedInvoices,
            returnControllerBalance: returnControllerBalance
        };

        return service;

        function getControllersByShipment(id) {
            var url = "api/controller/shipment/" + id;
            return $http.get(url);
        }

        function getControllersByInvoice(id) {
            var url = "api/controller/invoice/" + id;
            return $http.get(url);
        }

        function getControllersByShipmentAndInvoice(shipmentId, invoiceId) {
            var url = "/api/controller/shipment/" + shipmentId + "/invoice/" + invoiceId;
            return $http.get(url);
        }

        function returnUsedShipments() {
            var url = "/api/controller/shipments/filter";
            return $http.get(url);
        }

        function returnUsedInvoices() {
            var url = "/api/controller/invoices/filter";
            return $http.get(url);
        }

        function returnControllerBalance(id) {
            var url = "/api/controller/balance/" + id;
            return $http.get(url);
        }
    }
})();
